import { FieldErrors, FieldValues, Path } from "react-hook-form";

export function ErrorMessage<TFormValues extends FieldValues>({
	fieldError,
	componentId,
}: {
	fieldError: FieldErrors<TFormValues>[Path<TFormValues>] | undefined;
	componentId?: string;
}) {
	if (!fieldError || !fieldError.message) return <></>;

	return (
		<div id={componentId + "-error-message-text"} className="mt-2">
			<p className="text-sm text-red-600 font-normal leading-tight">
				{fieldError.message as string}
			</p>
		</div>
	);
}
